import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { CustomReportServiceBase } from './custom-report/custom-report-base.service';
import {
    BoxResultType,
    CustomReportServiceView,
    GetDataFilterValuesParameters,
    GetProjectModuleExpensesColumnChartValuesResultType,
    GetProjectModuleExpensesLineChartValuesResultType,
    GetProjectModuleExpensesMetricsValuesResultType,
    GetProjectModuleExpensesValuesResultType,
    ProjectExpensesClient,
    ReportResultColumnDto,
    SharedReportDto
} from './reporting-api-proxies';

@Injectable({
    providedIn: 'root'
})
export class ProjectExpensesService extends CustomReportServiceBase<ProjectExpensesClient, CustomReportServiceView> {
    constructor(protected override client: ProjectExpensesClient) {
        super(client);
    }

    async getValues(parameters: GetDataFilterValuesParameters): Promise<GetProjectModuleExpensesValuesResultType[]> {
        return await lastValueFrom(this.client.projectExpensesGetProjectModuleExpensesValues(parameters));
    }

    async getBoxesValues(parameters: GetDataFilterValuesParameters): Promise<BoxResultType[]> {
        return await lastValueFrom(this.client.projectExpensesGetProjectModuleExpensesBoxesValues(parameters));
    }

    async getColumnChartValues(
        parameters: GetDataFilterValuesParameters
    ): Promise<GetProjectModuleExpensesColumnChartValuesResultType[]> {
        return await lastValueFrom(this.client.projectExpensesGetProjectModuleExpensesColumnChartValues(parameters));
    }

    async getMetricsValues(
        parameters: GetDataFilterValuesParameters
    ): Promise<GetProjectModuleExpensesMetricsValuesResultType> {
        return await lastValueFrom(this.client.projectExpensesGetProjectModuleExpensesMetricsValues(parameters));
    }

    async getLineChartValues(
        parameters: GetDataFilterValuesParameters
    ): Promise<GetProjectModuleExpensesLineChartValuesResultType[]> {
        return await lastValueFrom(this.client.projectExpensesGetProjectModuleExpensesLineChartValues(parameters));
    }

    override async saveCustomReport(body: CustomReportServiceView): Promise<CustomReportServiceView> {
        if (body.isPublic) return await lastValueFrom(this.client.projectExpensesSaveCatalogReport(body));
        else return await lastValueFrom(this.client.projectExpensesSaveCustomReport(body));
    }

    override async getCustomReport(id: number): Promise<CustomReportServiceView> {
        return await lastValueFrom(this.client.projectExpensesGetCustomReport(id));
    }

    override async shareReport(body: CustomReportServiceView): Promise<SharedReportDto> {
        return await lastValueFrom(this.client.projectExpensesCreateSharedReport(body));
    }

    override async getSharedReport(id: string): Promise<CustomReportServiceView> {
        return await lastValueFrom(this.client.projectExpensesGetSharedReport(id));
    }

    override async getResultAvailableColumns(organizationIds: number[]): Promise<ReportResultColumnDto[]> {
        return await lastValueFrom(this.client.projectExpensesResultAvailableColumns(organizationIds));
    }
}
